import {
  mercadonaDomain,
  mercadonaDomainPortugal,
  CUSTOMER_SERVICE_LINKS,
  OLD_SHOP_LANGUAGES,
} from '../constants'
import i18next from 'i18next'
import facebookLogo from '../assets/icons/facebook.svg'
import outstandingLogo from '../assets/icons/mail.svg'
import instagramLogo from '../assets/icons/instagram.svg'
import linkedinLogo from '../assets/icons/linkedin.svg'
import tiktokLogo from '../assets/icons/tiktok.svg'
import xLogo from '../assets/icons/x.svg'
import youtubeLogo from '../assets/icons/youtube.svg'

const SELECTOR = '.o-footer'
const portalURL =
  'https://www.portalcliente.mercadona.es/pclie/web/op.htm?operation=pclie.flow.inicio&fwk.locale=es_ES'
const facturasURL = 'https://factura-me.mercadona.com/'
const portalTrinidadURL = 'https://portaltrinidad.mercadona.com/trinidad/ext'
const atencionCLienteURL = 'https://info.mercadona.es/'
const facebookURL = 'https://www.facebook.com/mercadona'
const youtubeURL = 'https://www.youtube.com/mercadona'
const instagramURL = 'https://www.instagram.com/mercadona/'
const twitterURL = 'https://twitter.com/mercadona'
const linkedinURL = 'https://es.linkedin.com/company/mercadona'
const tiktokURL = 'https://www.tiktok.com/@mercadona'
const rel = 'nofollow noopener noreferrer'

let node

const Footer = {
  mount(currentLanguage) {
    node = document.querySelector(SELECTOR)
    this.render(currentLanguage, node)
  },

  render(currentLanguage) {
    let englishLanguage = ''
    currentLanguage = OLD_SHOP_LANGUAGES[currentLanguage]
    if (currentLanguage === 'en') englishLanguage = '/in'

    const outstandingsUrl = [
      atencionCLienteURL,
      currentLanguage,
      CUSTOMER_SERVICE_LINKS[currentLanguage],
      '#destacadosFormulario',
    ].join('')

    return (node.innerHTML = `
        <div class="o-footer-contain">
          <div class="o-footer-links">
              <div class="o-footer-links-section">
                <ul>
                  <li>
                    <h3>${i18next.t('footer_section.boss.title')}</h3>
                  </li>
                  <li>
                    <a href="${mercadonaDomain}${currentLanguage}/supermercados" target="_blank" rel="${rel}">
                      ${i18next.t('footer_section.boss.option1')}
                    </a>
                  </li>
                  <li>
                    <a href="${mercadonaDomain}${currentLanguage}/consejos" target="_blank" rel="${rel}">
                      ${i18next.t('footer_section.boss.option2')}
                    </a>
                  </li>
                  <li>
                    <a href="${portalURL}" target="_blank" rel="${rel}">
                      ${i18next.t('footer_section.boss.option4')}
                    </a>
                  </li>
                </ul>
              </div>
              <div class="o-footer-links-section">
                <ul>
                  <li>
                    <h3>${i18next.t('footer_section.employee.title')}</h3>
                  </li>
                  <li>
                    <a
                      href="https://mercadona.avature.net/es_ES/Careers"
                      target="_blank"
                      rel="${rel}"
                    >
                        ${i18next.t('footer_section.employee.option1')}
                    </a>
                  </li>
                </ul>
              </div>
              <div class="o-footer-links-section">
                <ul>
                  <li>
                    <h3>${i18next.t('footer_section.provider.title')}</h3>
                  </li>
                  <li>
                    <a href="${facturasURL}" target="_blank" rel="${rel}"  aria-label="Factura-Me">
                      ${i18next.t('footer_section.provider.option1')}
                    </a>
                  </li>
                  <li>
                    <a href="${portalTrinidadURL}${englishLanguage}/Acceso.do" target="_blank" rel="${rel}">
                      ${i18next.t('footer_section.provider.option2')}
                    </a>
                  </li>
                </ul>
              </div>
              <div class="o-footer-links-section">
                <ul>
                  <li>
                    <h3>${i18next.t('footer_section.society.title')}</h3>
                  </li>
                  <li>
                    <a href="${mercadonaDomain}${currentLanguage}/actualidad" target="_blank" rel="${rel}">
                      ${i18next.t('footer_section.society.option1')}
                    </a>
                  </li>
                  <li>
                    <a href="${mercadonaDomain}${currentLanguage}/conocenos/sala-de-prensa"
                      target="_blank"
                      rel="${rel}"
                    >
                      ${i18next.t('footer_section.society.option2')}
                    </a>
                  </li>
                  <li>
                    <a href="${mercadonaDomain}${currentLanguage}/conocenos" target="_blank" rel="${rel}">
                      ${i18next.t('footer_section.society.option3')}
                    </a>
                  </li>
                  <li>
                    <a href="${mercadonaDomainPortugal}"
                      target="_blank"
                      rel="${rel}"
                    >
                      ${i18next.t('footer_section.society.option4')}
                    </a>
                  </li>
                  <li>
                    <a
                      href="${mercadonaDomain}${currentLanguage}/cuidemos-el-planeta"
                      target="_blank"
                      rel="${rel}"
                    >
                      ${i18next.t('footer_section.society.option5')}
                    </a>
                  </li>
                </ul>
              </div>
              <div class="o-footer-links-section">
                <div class="o-footer-phone-wrapper">
                  <a
                    class="o-footer-phone-link"
                    aria-label="Llamar a atención al cliente"
                    href="tel:800500220"
                  >
                    <div class="o-footer-phone">
                      <div class="o-footer-support"></div>
                      <div>800 500 220</div>
                    </div>
                  </a>
                </div>
                <ul class="o-footer-social">
                  <li class="o-footer-social-item">
                    <a aria-label="Formulario de contacto"
                      class="o-footer-social-link"
                      target="_blank"
                      rel="${rel}"
                      href="${outstandingsUrl}"
                    >
                    <img
                        class="o-footer-social-svg-icon"
                        src="${outstandingLogo}"
                        alt=""
                      />
                      </a>
                  </li>
                  <li class="o-footer-social-item">
                    <a aria-label="facebook"
                      class="o-footer-social-link"
                      target="_blank"
                      rel="${rel}"
                      href="${facebookURL}"
                    >
                      <img
                        class="o-footer-social-svg-icon"
                        src="${facebookLogo}"
                        alt=""
                      />
                    </a>
                  </li>
                  <li class="o-footer-social-item">
                    <a aria-label="twitter"
                      class="o-footer-social-link"
                      target="_blank"
                      rel="${rel}"
                      href="${twitterURL}"
                    >
                      <img
                        class="o-footer-social-svg-icon"
                        src="${xLogo}"
                        alt=""
                      />
                    </a>
                  </li>
                  <li class="o-footer-social-item">
                    <a aria-label="youtube"
                      class="o-footer-social-link"
                      target="_blank"
                      rel="${rel}"
                      href="${youtubeURL}"
                    >
                      <img
                        class="o-footer-social-svg-icon"
                        src="${youtubeLogo}"
                        alt=""
                      />
                    </a>
                  </li>
                  <li class="o-footer-social-item">
                    <a aria-label="instagram"
                      class="o-footer-social-link"
                      target="_blank"
                      rel="${rel}"
                      href="${instagramURL}"
                    >
                      <img
                        class="o-footer-social-svg-icon"
                        src="${instagramLogo}"
                        alt=""
                      />
                    </a>
                  </li>
                  <li class="o-footer-social-item">
                    <a aria-label="linkedin"
                      class="o-footer-social-link"
                      target="_blank"
                      rel="${rel}"
                      href="${linkedinURL}"
                    >
                      <img
                        class="o-footer-social-svg-icon"
                        src="${linkedinLogo}"
                        alt=""
                      />
                    </a>
                  </li>
                  <li class="o-footer-social-item">
                    <a aria-label="tiktok"
                      class="o-footer-social-link"
                      target="_blank"
                      rel="${rel}"
                      href="${tiktokURL}"
                    >
                      <img
                        class="o-footer-social-svg-icon"
                        src="${tiktokLogo}"
                        alt=""
                      />
                    </a>
                  </li>
                </ul>
              </div>
          </div>
        </div>
    `)
  },
}

export { Footer }
